import { render, staticRenderFns } from "./DeleteBenefitSuccessNotification.vue?vue&type=template&id=15c7c0c0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports